import homeService from '@/services/home'

export default {
  namespaced: true,

  state: {
    mainContent: null,
    alert: null,
    about: null,
  },

  mutations: {
    setMainContent(state, content) {
      state.mainContent = content
    },

    setAlert(state, alert) {
      state.alert = alert
    },

    setAbout(state, about) {
      state.about = about
    },
  },

  actions: {
    fetchHomeContents({ commit }) {
      return new Promise(resolve => {
        homeService.getHomeContents().then(res => {
          commit('setMainContent', res.main_content)
          commit('setAlert', res.alert)
          commit('setAbout', res.about)
          resolve(res.main_content.video)
        })
      })
    },
  },
}
